// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/* Theme fallbacks */
/* Gold palette (match CardComponent rows) */
/* classic gold */
/* highlight */
/* shadow */
/* --- Section (no outside gradient box) --- */
.agenda {
  /* transparent/plain container — no border, no shadow */
  font-family: "Almendra";
  background: transparent;
  padding: 25px;
  border: 0;
  box-shadow: none;
  margin: 0; /* adjust in page layout as needed */
}

.agenda__inner {
  padding: 0; /* no inner padding now that the outer box is removed */
}

/* Title (Great Vibes to match your theme) */
.agenda__title {
  font-family: "Great Vibes", cursive;
  font-weight: 400;
  line-height: 1.1;
  color: #0b0b0c;
  font-size: clamp(1.8rem, 5vw, 2.6rem);
  margin: 0 0 0.5rem 0;
  text-align: center;
}

/* ---------- Timeline list ---------- */
.agenda__list {
  list-style: none;
  margin: 0;
  padding: 0.3rem 0 0;
  display: grid;
  gap: 0.6rem;
}

/* Each row: pure white fill + gold gradient border */
.agenda__item {
  display: grid;
  grid-template-columns: 120px 16px 1fr; /* time | dot/line | label */
  align-items: center;
  gap: 0.6rem;
  border-radius: 12px;
  border: 1.5px solid transparent;
  background: linear-gradient(#fff, #fff) padding-box, linear-gradient(135deg, #d4af37, #f0e1a1 40%, #b38728) border-box;
  padding: 0.55rem 0.65rem;
  box-shadow: 0 1px 0 rgba(255, 255, 255, 0.7) inset, 0 6px 14px rgba(0, 0, 0, 0.04);
}
@media (max-width: 520px) {
  .agenda__item {
    grid-template-columns: 96px 14px 1fr;
  }
}

/* Time chip */
.agenda__time {
  justify-self: start;
  font-size: 0.95rem;
  color: #0b0b0c;
  padding: 0.25rem 0.5rem;
  border-radius: 10px;
  border: 1px solid rgba(240, 225, 161, 0.6);
  background: #fff;
  box-shadow: 0 1px 0 rgba(255, 255, 255, 0.7) inset;
  text-align: center;
}

/* Gold dot + faint connector line */
.agenda__dot {
  position: relative;
  width: 10px;
  height: 10px;
  border-radius: 999px;
  background: radial-gradient(circle at 30% 30%, #f0e1a1, #d4af37 70%);
  /* vertical connector */
}
.agenda__dot::after {
  content: "";
  position: absolute;
  left: 50%;
  top: 10px;
  width: 1px;
  height: calc(100% + 0.6rem); /* matches list gap for visual continuity */
  background: linear-gradient(180deg, rgba(212, 175, 55, 0.5), rgba(240, 225, 161, 0.15));
  transform: translateX(-50%);
}

/* Remove connector on last item */
.agenda__item:last-child .agenda__dot::after {
  display: none;
}

/* Label */
.agenda__label {
  font-size: 1rem;
  color: #0b0b0c;
  line-height: 1.45;
}

/* Slightly larger padding on wider screens (still no outer box) */
@media (min-width: 900px) {
  .agenda__inner {
    padding: 0.25rem 0;
  }
}`, "",{"version":3,"sources":["webpack://./src/AgendaComponent/AgendaComponent.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAEhB,oBAAA;AAKA,4CAAA;AACkB,iBAAA;AACA,cAAA;AACA,WAAA;AAElB,8CAAA;AACA;EACE,uDAAA;EACA,uBAAA;EACA,uBAAA;EACA,aAAA;EACA,SAAA;EACA,gBAAA;EACA,SAAA,EAAA,oCAAA;AALF;;AAQA;EACE,UAAA,EAAA,uDAAA;AALF;;AAQA,4CAAA;AACA;EACE,mCAAA;EACA,gBAAA;EACA,gBAAA;EACA,cA5BQ;EA6BR,qCAAA;EACA,oBAAA;EACA,kBAAA;AALF;;AAQA,wCAAA;AACA;EACE,gBAAA;EACA,SAAA;EACA,mBAAA;EACA,aAAA;EACA,WAAA;AALF;;AAQA,qDAAA;AACA;EACE,aAAA;EACA,qCAAA,EAAA,4BAAA;EACA,mBAAA;EACA,WAAA;EAEA,mBAAA;EACA,+BAAA;EACA,sHACE;EAGF,wBAAA;EACA,kFACE;AAVJ;AAaE;EAjBF;IAkBI,oCAAA;EAVF;AACF;;AAaA,cAAA;AACA;EACE,mBAAA;EACA,kBAAA;EACA,cAtEQ;EAuER,uBAAA;EACA,mBAAA;EACA,0CAAA;EACA,gBAAA;EACA,kDAAA;EACA,kBAAA;AAVF;;AAaA,oCAAA;AACA;EACE,kBAAA;EACA,WAAA;EAAa,YAAA;EACb,oBAAA;EACA,oEAAA;EAEA,uBAAA;AAVF;AAWE;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,SAAA;EACA,UAAA;EACA,2BAAA,EAAA,2CAAA;EACA,uFAAA;EACA,2BAAA;AATJ;;AAaA,kCAAA;AACA;EAA+C,aAAA;AAT/C;;AAWA,UAAA;AACA;EACE,eAAA;EACA,cAzGQ;EA0GR,iBAAA;AARF;;AAWA,kEAAA;AACA;EACE;IAAiB,kBAAA;EAPjB;AACF","sourcesContent":["@use \"../styles/tokens\" as *;\r\n\r\n/* Theme fallbacks */\r\n$primary: if(global-variable-exists(color-primary), $color-primary, #7c3aed);\r\n$text:    if(global-variable-exists(color-text),   $color-text,   #0b0b0c);\r\n$muted:   if(global-variable-exists(color-muted),  $color-muted,  #6b7280);\r\n\r\n/* Gold palette (match CardComponent rows) */\r\n$gold-1: #d4af37; /* classic gold */\r\n$gold-2: #f0e1a1; /* highlight */\r\n$gold-3: #b38728; /* shadow */\r\n\r\n/* --- Section (no outside gradient box) --- */\r\n.agenda {\r\n  /* transparent/plain container — no border, no shadow */\r\n  font-family: 'Almendra';\r\n  background: transparent;\r\n  padding: 25px;\r\n  border: 0;\r\n  box-shadow: none;\r\n  margin: 0; /* adjust in page layout as needed */\r\n}\r\n\r\n.agenda__inner {\r\n  padding: 0; /* no inner padding now that the outer box is removed */\r\n}\r\n\r\n/* Title (Great Vibes to match your theme) */\r\n.agenda__title {\r\n  font-family: 'Great Vibes', cursive;\r\n  font-weight: 400;\r\n  line-height: 1.1;\r\n  color: $text;\r\n  font-size: clamp(1.8rem, 5vw, 2.6rem);\r\n  margin: 0 0 .5rem 0;\r\n  text-align: center;\r\n}\r\n\r\n/* ---------- Timeline list ---------- */\r\n.agenda__list {\r\n  list-style: none;\r\n  margin: 0;\r\n  padding: .3rem 0 0;\r\n  display: grid;\r\n  gap: .6rem;\r\n}\r\n\r\n/* Each row: pure white fill + gold gradient border */\r\n.agenda__item {\r\n  display: grid;\r\n  grid-template-columns: 120px 16px 1fr; /* time | dot/line | label */\r\n  align-items: center;\r\n  gap: .6rem;\r\n\r\n  border-radius: 12px;\r\n  border: 1.5px solid transparent;\r\n  background:\r\n    linear-gradient(#fff, #fff) padding-box,\r\n    linear-gradient(135deg, $gold-1, $gold-2 40%, $gold-3) border-box;\r\n\r\n  padding: .55rem .65rem;\r\n  box-shadow:\r\n    0 1px 0 rgba(255,255,255,.7) inset,\r\n    0 6px 14px rgba(0,0,0,.04);\r\n\r\n  @media (max-width: 520px) {\r\n    grid-template-columns: 96px 14px 1fr;\r\n  }\r\n}\r\n\r\n/* Time chip */\r\n.agenda__time {\r\n  justify-self: start;\r\n  font-size: .95rem;\r\n  color: $text;\r\n  padding: .25rem .5rem;\r\n  border-radius: 10px;\r\n  border: 1px solid rgba($gold-2, .6);\r\n  background: #fff;\r\n  box-shadow: 0 1px 0 rgba(255,255,255,.7) inset;\r\n  text-align: center;\r\n}\r\n\r\n/* Gold dot + faint connector line */\r\n.agenda__dot {\r\n  position: relative;\r\n  width: 10px; height: 10px;\r\n  border-radius: 999px;\r\n  background: radial-gradient(circle at 30% 30%, $gold-2, $gold-1 70%);\r\n\r\n  /* vertical connector */\r\n  &::after {\r\n    content: \"\";\r\n    position: absolute;\r\n    left: 50%;\r\n    top: 10px;\r\n    width: 1px;\r\n    height: calc(100% + .6rem); /* matches list gap for visual continuity */\r\n    background: linear-gradient(180deg, rgba($gold-1,.5), rgba($gold-2,.15));\r\n    transform: translateX(-50%);\r\n  }\r\n}\r\n\r\n/* Remove connector on last item */\r\n.agenda__item:last-child .agenda__dot::after { display: none; }\r\n\r\n/* Label */\r\n.agenda__label {\r\n  font-size: 1rem;\r\n  color: $text;\r\n  line-height: 1.45;\r\n}\r\n\r\n/* Slightly larger padding on wider screens (still no outer box) */\r\n@media (min-width: 900px) {\r\n  .agenda__inner { padding: .25rem 0; }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
